import { Queue } from 'utility/queue';
import { RTCInboundRtpVideoStreamStats } from './types';

export type StreamSelectorResult
    = number // index of the selected stream 
    | 'matched' // couldn't decide
    | 'deferred' // should stay with current stream

export interface StreamSelectorInterface {
    label(): string;
    description(): unknown;
    batchUpdate(streams: Queue<RTCInboundRtpVideoStreamStats>[]): void;
    get(): StreamSelectorResult;
    filtered(fn: (result: StreamSelectorResult) => StreamSelectorResult): StreamSelectorInterface;
}

export abstract class StreamSelectorBase implements StreamSelectorInterface {
    abstract label(): string;
    abstract description(): unknown;
    abstract batchUpdate(streams: Queue<RTCInboundRtpVideoStreamStats>[]): void;
    abstract get(): StreamSelectorResult;

    filtered(fn: (result: StreamSelectorResult) => StreamSelectorResult): StreamSelectorInterface {
        return new FilteredStreamSelector(this, fn);
    }
}

class FilteredStreamSelector extends StreamSelectorBase implements StreamSelectorInterface {
    constructor(private wrapped: StreamSelectorInterface,
        private fn: (result: StreamSelectorResult) => StreamSelectorResult,
        private filterName: string = '') {
        super();
    }

    label() {
        return `${this.wrapped.label()}.filtered(${this.filterName})`;
    }

    description(): unknown {
        return { filtered: this.filterName, wrapped: this.wrapped.description() };
    }

    batchUpdate(streams: Queue<RTCInboundRtpVideoStreamStats>[]): void {
        this.wrapped.batchUpdate(streams);
    }

    get(): StreamSelectorResult {
        return this.fn(this.wrapped.get());
    }
}
